export default __webpack_public_path__ + "static/media/contact-mobile.9c5ae72a.jpg";